import React, { useEffect, useState } from "react";
import Logo3D from "./Logo3D";

/**
 * BrandLogos3D — the three sister-company marks shown ONE AT A TIME, cycling:
 * S.S. White -> Shukla Medical -> Shukla Surgical Support -> repeat. Each mark
 * is the real logo, full color, spinning in 3D like a coin. The visible one
 * swaps on an interval with a soft cross-fade.
 *
 * Class hooks (for sidebar collapse CSS): .brand3d-mark / .brand3d-label /
 * .brand3d-dots.
 *
 * Props:
 *   size, secPerTurn, holdMs, labels, spin
 */

const COMPANIES = [
  { company: "ssw", label: "S.S. White Technologies" },
  { company: "shuklaMedical", label: "Shukla Medical" },
  { company: "shuklaSurgical", label: "Shukla Surgical Support" },
];

const BrandLogos3D = ({
  size = 120,
  secPerTurn = 7,
  holdMs = 3600,
  labels = false,
  spin = true,
  showDots = true,
  style,
}) => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const fade = 420;
    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % COMPANIES.length);
        setVisible(true);
      }, fade);
    }, holdMs);
    return () => clearInterval(t);
  }, [holdMs]);

  const c = COMPANIES[idx];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        ...style,
      }}
    >
      <div
        className="brand3d-mark"
        style={{
          opacity: visible ? 1 : 0,
          transition: "opacity 0.42s ease",
          height: size,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Logo3D
          key={c.company}
          company={c.company}
          size={size}
          secPerTurn={secPerTurn}
          spin={spin}
        />
      </div>
      {labels && (
        <span
          className="brand3d-label"
          style={{
            opacity: visible ? 1 : 0,
            transition: "opacity 0.42s ease",
            fontSize: Math.max(12, size * 0.11),
            fontWeight: 700,
            letterSpacing: "0.03em",
            color: "var(--ssw-brand-ink, #16447a)",
            fontFamily: "'Inter', -apple-system, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap",
            lineHeight: 1.1,
          }}
        >
          {c.label}
        </span>
      )}
      {showDots && (
        <span className="brand3d-dots" aria-hidden="true" style={{ display: "inline-flex", gap: 6 }}>
          {COMPANIES.map((_, i) => (
            <i
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: i === idx ? "#16447a" : "var(--ssw-tint-blue, #c7d0e0)",
                display: "inline-block",
                transition: "background 0.3s ease",
              }}
            />
          ))}
        </span>
      )}
    </div>
  );
};

export default BrandLogos3D;
